import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

@Component({
  selector: 'app-lead-insight',
  templateUrl: './lead-insight.component.html',
})
export class LeadInsightComponent implements OnInit {

  insight$ = this.dashboardService.getLeadInsight();

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

}
